export default __webpack_public_path__ + "static/media/video-sdg-10.d09647a9.mp4";